import { webApiEndpoints } from "../config"
import { AppCategories, AppRequestType, PathAppOptions, SwaggerApiType } from "../types"

const category: AppCategories = 'thirdParty'

export const apidocAdapter = {
    
    listApis: function (origin: string, page: string): AppRequestType<SwaggerApiType[]>[typeof category]['getApiList'] {
        let pathVariables: Map<PathAppOptions, string> = new Map();
        pathVariables.set('{origin}', origin);
        pathVariables.set('{groupId}', page);
        return {
            endpoint: webApiEndpoints[category].getApiList,
            parameters: { pathVariables },
            input: null,
            isSuccesful: response => !!response.data.name,
            output: (data) => data.apis,
            hideError: true
        }
    }

}